import React, { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './style/Login.module.css';

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const tenant = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get('tenant')?.trim() || 'tenant_a';
  }, [location.search]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!username || !password) {
      setError('Username e password sono obbligatori');
      return;
    }

    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Tenant-Key': tenant,
        },
        credentials: 'include',
        body: JSON.stringify({
          username: username.trim(),
          password: password.trim(),
          tenant_key: tenant,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        navigate(`/home?tenant=${encodeURIComponent(tenant)}`);
      } else {
        setError(data.message || 'Errore durante il login');
      }
    } catch {
      setError('Errore nella connessione al server');
    }
  };

  return (
    <div className={styles.loginPage}>
      <div className={styles.leftSection}>
        <h1>Hi, Welcome Back!</h1>
      </div>

      <div className={styles.rightSection}>
        <div className={styles.loginHeader}>
          <h2>Login</h2>
        </div>

        <form onSubmit={handleLogin} className={styles.loginForm}>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button type="submit">Login</button>

          {error && <p className={styles.errorMsg}>{error}</p>}
        </form>
      </div>
    </div>
  );
};

export default Login;